<template>

</template>

<script>
    export default {
        name: "live"
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/characteristic/live.vue